import React from 'react'
import { NavLink } from 'react-router-dom'
import styles from './styles.module.scss'
import logo from 'sdss/assets/images/logo.png'
import logo_white from 'sdss/assets/images/logo_white.png'
import { NavsProps } from '..'

export default function Header(props: NavsProps) {
  const { showDefaultBgColor = true } = props

  function NavItems() {

    return (
      <div data-flex className={`${showDefaultBgColor ? styles.colorWhite : styles.colorBlue}`}>
        <div className={styles.navItem}>
          <NavLink to='/' activeClassName={styles.activeNav}>文献热点分析</NavLink>
        </div>
        <div className={styles.navItem}>
          <a href="https://ncrcrd.einmatrix.com/%E4%B8%AD%E5%BF%83%E4%BB%8B%E7%BB%8D/%E4%B8%AD%E5%BF%83%E7%AE%80%E4%BB%8B/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/%E6%96%B9%E6%B3%95%E5%AD%A6%E9%97%A8%E8%AF%8A/" target="_blank" rel="noopener noreferrer">方法学门诊</a>
        </div>
        <div className={styles.navItem}>
          <a href="https://edu.chinarespiratory.org/course/39" target="_blank" rel="noopener noreferrer">研究设计课程</a>
        </div>
      </div>
    )
  }

  const navbarDivStyle = {
    color: showDefaultBgColor ? '#333' : '#fff',
    backgroundColor: showDefaultBgColor ? '#fff' : '',
    boxShadow: showDefaultBgColor ? '0px 2px 12px 0px rgba(116,116,116,0.2)' : ''
  }

  const navbarContentDivStyle = {
    width: showDefaultBgColor ? 850 : 1200
  }

  return (
    <div className={styles.navbar} style={navbarDivStyle}>
        <div className={styles.navbarContent} style={navbarContentDivStyle}>
          <div className={styles.title}>
            <div>
              <img src={showDefaultBgColor ? logo : logo_white } alt="logo" width="29px" />
            </div>
            <span style={{ marginLeft: 10 }}>研究设计辅助</span>
          </div>
          <div className={styles.navItems}>
            {NavItems()}
          </div>
        </div>
      </div>
  )
}
